import { IContractResponse } from 'services/contract/types';
import { IContractTemplateForm, TEMPLATE_TYPE } from 'services/templates/types';
import { contractTemplateUtil } from 'utils';
import { connectContractTreeItems } from './contractQueryItemConnector';

export const contractQueryToForm = (
  data?: IContractResponse,
  lowestAvailableId?: string
): IContractTemplateForm => ({
  ...contractTemplateUtil.form.initialValues,
  items: data
    ? [
        {
          id: '0',
          type: TEMPLATE_TYPE.contract,
          content: data.title,
          children: connectContractTreeItems(
            {
              customSections: data.customSections,
              digitalDistribution: data.digitalDistributionSection ?? undefined,
              physicalDistribution:
                data.physicalDistributionSection ?? undefined,
              merchDistribution: data.merchDistributionSection ?? undefined,
              channelDistribution: data.channelDistributionSection ?? undefined,
            },
            lowestAvailableId ?? '1'
          ),
          disabledCollapse: true,
          disabledSelection: true,
          disabledRemove: true,
          autoFocus: true,
        },
      ]
    : contractTemplateUtil.contract.initialValues,
  details: data
    ? {
        endDate: data.endDate
          ? new Date(data.endDate).toISOString().slice(0, 10)
          : '',
        startDate: new Date(data.startDate).toISOString().slice(0, 10),
        status: data.status,
        withEndDate: !!data.endDate,
      }
    : undefined,
  version: data?.version ?? 0,
});
